import { render, staticRenderFns } from "./FormularioCadastroUnidadesNegocio.vue?vue&type=template&id=32db2f77&"
import script from "./FormularioCadastroUnidadesNegocio.vue?vue&type=script&lang=js&"
export * from "./FormularioCadastroUnidadesNegocio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports